export default __webpack_public_path__ + "static/media/FNL_thumb.dba6095e.jpg";